import React from "react";
import { motion } from "framer-motion";
import AnimatedCounter from "@/components/site/AnimatedCounter";
import { Sparkles, Layers, Timer, TrendingUp } from "lucide-react";
import { STATS } from "@/constants/testIds";

const ITEMS = [
  {
    key: "active",
    icon: Sparkles,
    counter: { to: 5, suffix: "" },
    title: "Active Projects",
    note: "Building with purpose. Growing one launch at a time.",
  },
  {
    key: "industries",
    icon: Layers,
    counter: { to: 5, suffix: "" },
    title: "Industries",
    note: "From cafés to campuses — we&apos;re already creating impact.",
  },
  {
    key: "delivery",
    icon: Timer,
    label: "48h",
    title: "Launch Promise",
    note: "Once your design is approved, we move fast.",
  },
  {
    key: "growth",
    icon: TrendingUp,
    label: "100%",
    title: "Commitment",
    note: "Every project gets our full attention.",
  },
];

const Stats = () => {
  return (
    <section
      id="stats"
      data-testid={STATS.root}
      className="relative border-y border-white/[0.06] bg-[#08080a] py-16 lg:py-24"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="mb-10 flex items-center gap-3">
          <div className="h-px w-8 bg-[var(--gold)]/60" />
          <span className="font-mono-label text-[var(--gold)]">
            Real Progress · Real Momentum
          </span>
        </div>

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {ITEMS.map((item, idx) => (
            <motion.div
              key={item.key}
              data-testid={`${STATS.itemPrefix}-${item.key}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{
                duration: 0.7,
                delay: idx * 0.08,
                ease: [0.2, 0.8, 0.2, 1],
              }}
              className="group relative overflow-hidden rounded-2xl border border-white/[0.06] bg-[#0e0e10] p-6 transition-all duration-500 hover:border-[var(--gold)]/25"
            >
              <div className="flex items-start justify-between">
                <div className="grid h-10 w-10 place-items-center rounded-lg border border-white/10 bg-white/[0.03] text-[var(--gold-bright)]/85 transition-colors duration-500 group-hover:border-[var(--gold)]/40 group-hover:bg-[var(--gold)]/10">
                  <item.icon className="h-5 w-5" strokeWidth={1.6} />
                </div>
              </div>
              <div className="mt-6 font-display text-[42px] font-semibold leading-none tracking-tight text-white">
                {item.counter ? (
                  <AnimatedCounter to={item.counter.to} suffix={item.counter.suffix} />
                ) : (
                  <span className="gold-gradient-text">{item.label}</span>
                )}
              </div>
              <div className="mt-3 font-display text-[15px] font-medium text-white">
                {item.title}
              </div>
              <div className="mt-1.5 text-[13px] leading-relaxed text-zinc-500">
                {item.note}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
